import { IFieldSubmissionMap, IFormFieldSubmission } from "@common/redux/formSubmission/interface";
import { FieldRulesDetails, IFieldRuleConfig, MAX_OPTION, MIN_OPTION } from "@presentation/FormBuilder/Rules/config";
import { validateSubRule } from "@presentation/FormBuilder/utils";
import { DataUtility as _ } from "@utils/DataUtility";
import { FieldProps, SelectionTypes } from "../../FormFieldSelector/interfaces";

export const getInitialRuleConfigMultipleChoice = (
  rule: string
): IFieldRuleConfig => {
  const ruleDetails = FieldRulesDetails[rule];

  switch (rule) {
    case MAX_OPTION:
    case MIN_OPTION:
      return {
        rule,
        value: undefined,
        errorMessage: ruleDetails.defaultErrorMessage || "",
      };
    default:
      return {
        rule,
        value: "",
        errorMessage: "",
      } as IFieldRuleConfig;
  }
};

export const validateMultipleChoicesFieldSubmissionData = (
  fieldEditConfig: FieldProps,
  fieldSubmissionData: IFormFieldSubmission,
  fieldSubmissionMap: IFieldSubmissionMap,
): [boolean, string] => {
  const { fieldValue, isRequired, rules: fieldRules, isVisible } = fieldEditConfig;
  const fieldSubmissionValue = fieldSubmissionData?.fieldSubmissionValue || {};
  const { selectedOptions = [], selectedOption } = fieldSubmissionValue || {};

  let isNotEmpty: any;
  if (fieldValue.selectedType == SelectionTypes?.MULTIPLE_SELECTION) {
    isNotEmpty = selectedOptions?.length || false;
  } else {
    isNotEmpty = !_.isEmpty(selectedOption);
    if (!selectedOption?.optionKey) {
      isNotEmpty = false;
    }
  }
  if (isRequired && !!isVisible) {
    if (!isNotEmpty) {
      return [false, "This is a Required Field"];
    }
  }
  if (fieldRules) {
    for (let i = 0; i < fieldRules.length; i++) {
      const [isValidated, validatationErrorMessage] = validationRule(
        fieldRules[i],
        selectedOptions,
        fieldSubmissionMap
      );

      if (!isValidated && validatationErrorMessage != "") {
        return [isValidated, validatationErrorMessage];
      }
    }
  }

  return [true, ""];
};

export const validationRule = (
  fieldRule: IFieldRuleConfig,
  submissionValue: any,
  fieldSubmissionMap: IFieldSubmissionMap,
): [boolean, string] => {
  const { rule, value, errorMessage, subRules } = fieldRule;
  const ruleType: string = rule;
  const ruleValue: number = parseInt(`${value}`);
  const ruleErrorValue: string = errorMessage;

  switch (ruleType) {
    case "MAX_OPTION":
      if (ruleValue < submissionValue)
        return [false, ruleErrorValue];

      break;

    case "MIN_OPTION":
      if (ruleValue > submissionValue)
        return [false, ruleErrorValue];

      break;

    default:
      break;
  }

  if (subRules?.length > 0) {
    const [isValidated, validatationErrorMessage] = validateSubRule(fieldRule, value, fieldSubmissionMap, validationRule);
    return [isValidated, validatationErrorMessage];
  }

  return [true, ""];
};
